import { render } from "./SiteMenu.vue?vue&type=template&id=ab6e8054&scoped=true"
import script from "./SiteMenu.vue?vue&type=script&lang=js"
export * from "./SiteMenu.vue?vue&type=script&lang=js"

import "./SiteMenu.vue?vue&type=style&index=0&id=ab6e8054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab6e8054"]])

export default __exports__